import styled from 'styled-components';
import { ColorAddiWhite } from '@addi/foundation/dist/web/colors';
export const MINIMUM_WIDTH_RESPOSIVENESS = '1350px';
export const Header = styled.div `
  width: 100%;
  position: ${({ showMenu }) => (showMenu ? 'fixed' : 'relative')};
  background-color: ${({ showMenu }) => (showMenu ? ColorAddiWhite : 'transparent')};
  top: 0;
  max-width: 1300px;
  margin: 0 auto;
  left: 0;
  right: 0;
  @media (min-width: ${MINIMUM_WIDTH_RESPOSIVENESS}) {
    position: relative;
    background-color: transparent;
  }
`;
export const HeaderContainer = styled.div `
  align-items: center;
  display: flex;
  justify-content: space-between;
  position: relative;
  padding: 22px 24px;
  margin: 0;
  @media (min-width: ${MINIMUM_WIDTH_RESPOSIVENESS}) {
    justify-content: space-between;
    align-items: center;
    padding: 0;
    position: relative;
  }
`;
export const HeaderNavContainer = styled.nav `
  text-align: center;
  display: ${({ showMenu }) => (showMenu ? 'block' : 'none')};
  top: 70px;
  right: 0;
  height: 100vh;
  z-index: 0;
  position: fixed;
  width: 100%;
  background-color: ${ColorAddiWhite};
  @media (min-width: ${MINIMUM_WIDTH_RESPOSIVENESS}) {
    display: block;
    position: relative;
    top: 0;
    left: ${({ isBr }) => (isBr ? '62%' : 'auto')};
    height: auto;
    width: auto;
    background-color: transparent;
  }
`;
export const HeaderNavToggle = styled.div `
  text-align: center;
  float: right;
  margin-right: 10px;
  cursor: pointer;
  display: block;
  @media (min-width: ${MINIMUM_WIDTH_RESPOSIVENESS}) {
    display: none;
  }
`;
export const HeaderNavToggleIcon = styled.div `
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  background-image: ${({ showClose }) => `url(${showClose
    ? 'https://statics.addi.com/ui-storybook/close.svg'
    : 'https://statics.addi.com/ui-storybook/menu_open.png'})`};
  /* background-image: url(https://statics.addi.com/ui-storybook/menu_open.png); */
  background-size: contain;
`;
export const HeaderNavUser = styled.div `
  display: none;
  @media (min-width: ${MINIMUM_WIDTH_RESPOSIVENESS}) {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width:  ${({ isBr }) => (isBr ? '100%' : 'auto')};
  }
`;
export const MobileIcon = styled.div `
  display: block;
  cursor: pointer;
  @media (min-width: ${MINIMUM_WIDTH_RESPOSIVENESS}) {
    display: none;
  }
`;
export const UserImage = styled.img `
  display: ${({ isLoggedIn }) => (isLoggedIn ? 'none' : 'block')};
  @media (min-width: ${MINIMUM_WIDTH_RESPOSIVENESS}) {
    display: block;
  }
`;
//# sourceMappingURL=header-menu.styled.js.map